import {Routes} from '@angular/router';
import {MnewsDistComponent} from './mnews-dist.component';
import {GrievanceComponent} from './_components/grievance/grievance.component';
import {AppChannelComponent} from './_components/app-channel/app-channel.component';
import {CasemanagerComponent} from './_components/casemanager/casemanager.component';

export const mnewsDistRoutes: Routes = [
    {
        path: 'mnews-dist', component: MnewsDistComponent, children: [
            {path: 'mnews/:ai_id', component: AppChannelComponent},
            {path: 'casemanager/:ai_id', component: CasemanagerComponent},
            {path: 'dashboard', component : GrievanceComponent}
        ]
    }
];
